
<app-header></app-header>

<app-landing-carousel></app-landing-carousel>

<app-whats-new></app-whats-new>

<app-about-us></app-about-us>

<app-map-area></app-map-area>

<app-news-tenders></app-news-tenders>

<app-social-media></app-social-media>

<app-clients></app-clients>

<app-footer></app-footer>